import { api } from 'shared/sdk';

export const COMPANY_TYPES = {
  COMPANY: { api: api.joinCompany },
  SERVICE_PROVIDER: { api: api.joinServiceProvider },
  INVESTOR: { api: api.joinInvestor }
};
